module.exports = __webpack_public_path__ + "7be3dc5a3ed6c7df309f10ea30b0cfae.png";